'use strict';

frontendApp.controller('404Ctrl', ['$rootScope', '$scope', 'NavigationService', function($rootScope, $scope, NavigationService) {
    NavigationService.clearActiveTab();
    $rootScope.$broadcast('clearCurrentSelected');

    var max404 = 14;
    var num = Math.floor(Math.random() * max404) + 1;
    $scope.randomNumber = Math.floor(Math.random() * max404) + 1;
    
}]);
